
export const authFeatureKey = "auth"
export const layoutFeatureKey = "layout"
export const faqFeatureKey = "faq"